import ServiciosDelAPI from 'servicios/ServiciosDelAPI';
import { TOKEN_DE_ACCESO, publicMenu } from 'constantes/index';

export default class UserAccount{
    constructor(){
        this.email="";
        this.password="";
        this.authenticated=false;
        this.currentUser=null;
        this.menu=[];
        this.isError=false;
        this.errorMessage="";
        this.errors=[];
        this.userConfiguration=null;
    }
    setEmail(_email){ this.email=_email;};
    setPassword(_password){ this.password=_password;};
    getAuthenticated(){ return this.authenticated;};
    getCurrentUser(){ return this.currentUser;};
    getMenu(){ return this.menu; };
    getIsError(){ return this.isError;};
    getErrorMessage(){ return this.errorMessage; };
    getErrors(){return this.errors;};
    getUserConfiguration(){ return this.userConfiguration;};

    async setCurrentUser(){
        const currentUser = await ServiciosDelAPI.seguridadDeSSOUsuario.getCurrentUser();
        this.authenticated= true;
        this.currentUser= currentUser;
    }

    async setMenu(){
        this.menu=[];
        const menuResponse = await ServiciosDelAPI.seguridadDeSSOUsuario.getUserMenu();
        if (menuResponse.data!=="") this.menu= JSON.parse(menuResponse.data);
        this.menu= [...this.menu, ...publicMenu]
    }

    async login(){
        const loginRequest = Object.assign({}, {"email": this.email, "password": this.password});
        await ServiciosDelAPI.seguridadDeSSOUsuario.login(loginRequest)
        .then(async(response) => {
            localStorage.setItem(TOKEN_DE_ACCESO, response.accessToken);
            await this.setCurrentUser();
            await this.setMenu();
            this.isError=false;
            this.errorMessage="";
            this.errror=[];
        }).catch(error => {
            this.authenticated= false;
            this.currentUser= null;
            this.menu=[];
            this.isError=true;
            this.errors=error.errors;
            this.errorMessage=(error && error.message) || 'algo esta mal. Por favor intenta de nuevo!';
        });
    }

    logout(){
        localStorage.removeItem(TOKEN_DE_ACCESO);
    }
}